import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getHrLocationsApi,
  saveHrLocationsApi,
  deleteHrLocationsApi,
} from "../../apiservice/hrpayroll";

// ✅ Fetch branch location
export const fetchBranchLocation = createAsyncThunk(
  "branchLocation/fetchBranchLocation",
  async (branch_id, { rejectWithValue }) => {
    try {
      const res = await getHrLocationsApi({ branch_id });
      if (res.status !== 200) throw new Error(res.data?.msg || "Failed to fetch location");
      return res.data?.data || null;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// ✅ Save branch location
export const saveBranchLocation = createAsyncThunk(
  "branchLocation/saveBranchLocation",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await saveHrLocationsApi(payload);
      if (res.status !== 200) throw new Error(res.data?.msg || "Failed to save location");
      return payload; // return saved payload
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// ✅ Delete branch location
export const deleteBranchLocation = createAsyncThunk(
  "branchLocation/deleteBranchLocation",
  async (branch_id, { rejectWithValue }) => {
    try {
      const res = await deleteHrLocationsApi({ id: branch_id });
      if (res.status !== 200) throw new Error(res.data?.msg || "Failed to delete location");
      return branch_id;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
